<template>
  <div :id="'parts_db'">
    <div class="title_div">
      <span class="site">{{site_title}}</span>
      <!-- <a class="site_link" :href="raw_data.url">view page</a> -->
    </div>
    <vue-good-table v-if="(rows.length > 0)" ref="thisTable"
      id="green-dtable" 
      :columns="columns"
      :rows="rows"
      :row-style-class="rowStyleFn"
      :pagination-options="{
        enabled: is_paged
      }"
      @on-page-change="onTableChange"
      @on-per-page-change="onTableChange"
      @on-sort-change="onTableChange"
      @on-row-dblclick="onRowDblClick"
      >
        <template v-slot:table-row="props">
          <span v-if="(props.column.field == 'part_number') & (props.row.part_number != searchStore.part_selected) & show_red_parts">
            <span class="has-text-danger">{{props.row.part_number}}</span> 
          </span>
          <span v-else-if="(props.column.field == 'part_number_manufacturer') & (props.row.part_number_manufacturer != searchStore.part_selected) & show_red_parts">
            <span class="has-text-danger">{{props.row.part_number_manufacturer}}</span>
          </span>
          <span v-else-if="props.column.field == 'source'">
            <a :href=props.row.url target="_blank">{{props.formattedRow[props.column.field]}}</a>
          </span>
          <span v-else-if="props.column.field == 'description'">
            <span v-if="props.formattedRow[props.column.field].length > 150" :title=props.formattedRow[props.column.field]>
              {{props.formattedRow[props.column.field].substring(0,150)}} ...
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </span>
          <div v-else-if="props.column.field == 'common_attributes'">
            <div v-if="props.row[props.column.field] == null">
              {{props.formattedRow[props.column.field]}}
            </div>
            <div v-else-if=" Object.keys(props.row[props.column.field]).length > 2" :title="get_attr_title(props.row[props.column.field])">
              <!-- Object.keys(props.row[props.column.field]).length  -->
              <div v-for="(value, key, idx) in props.row[props.column.field]" :key="key">
                <div v-if="idx < 2">
                  {{ key }} : {{ value }}
                </div>
              </div> 
              ...
            </div>
            <div v-else>
              <div v-for="(value, key) in props.row[props.column.field]" :key="key">
                {{ key }} : {{ value }}
              </div>
            </div>
          </div>
          <div v-else-if="props.column.field == 'bulk_prices'">
            <div v-if="props.row[props.column.field] == null">
              {{props.formattedRow[props.column.field]}}
            </div>
            <div v-else-if=" Object.keys(props.row[props.column.field]).length > 2" :title="get_attr_title(props.row[props.column.field])">
              <!-- Object.keys(props.row[props.column.field]).length  -->
              <div v-for="(value, key, idx) in props.row[props.column.field]" :key="key">
                <div v-if="idx < 2">
                  {{ key }} : {{ value }}
                </div>
              </div> 
              ...
            </div>
            <div v-else>
              <div v-for="(value, key) in props.row[props.column.field]" :key="key">
                {{ key }} : {{ value }}
              </div>
            </div>
          </div>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
    </vue-good-table>
  </div>
</template>

<style scoped>
  .title_div{
    margin-top: 1.5em;
  }

  /deep/ #green-dtable .vgt-table thead th{
      /* background-color:#42b983 */

  }
  
  /deep/ table.vgt-table td{
      padding:0.2em;
      
  }
  /deep/ .row_style_class{
    max-height: 200px;
  }

  .site{
    font-size: 2em;
  }

  .site_link{
    margin-left: 0.5em;
    font-size: 0.7em;
    color: #42b983;
  }
</style>

<script>
  // import the styles
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';

  export default {
    name: 'DataTablePartDb',
    components: {
      VueGoodTable,
    },
    props: {
      site_title: null,
      raw_data: {"part": "3059788-01", "found": true, "site": "Sales", "data": [{"part_number": "3059788-01", "description": "FILTER AIR-P3", "qty_ship": 2, "unit_cost": "533.07", "total_cost": "1066.14", "vendor_name": "TEXTRON", "original_po_number": "P902", "bill_name": "DYNCORP INTERNATIONAL", "company_po_number": "TACLS19638", "unit_price": "574.05", "total_price": "1148.10", "margin": "7.14%", "profit": "81.96"}], "href": "#", "errors": []},
      rows:null,
      columns:null,
      test:null,
      columns_from_parent: null,
      customer: null,
      show_red_parts: {
        type: Boolean,
        default: true
      }
    },
    computed:{
      // columns: function(){
      //   function toTitleCase(input){
      //       return input
      //               .split('_')
      //               .map(i => i[0].toUpperCase() + i.substring(1))
      //               .join(' ') 
      //   }
      //   let cols = []
      //   if(this.columns_from_parent){
      //     // Use the columns as provided by parent
      //     cols = this.columns_from_parent
      //   }else{
      //     // Create columns from unknown data structure
      //     let data =this.raw_data.data
      //     // Check for data
      //     if(data.length==0){
      //       // Deep clone the original object
      //       data = JSON.parse(JSON.stringify(this.raw_data.data))
      //       // Display a single row if there's no data
      //       data.push({'Data':'None'})
      //     }
      //     // Get column names from keys of every row (could be different)
      //     let col_names = []
      //     for(let row in data){
      //       for (const key in data[row]) {
      //         if(col_names.indexOf(key) <0){
      //             col_names.push(key)
      //             let col = {
      //                     label: toTitleCase(key),
      //                     field: key,
      //                   }
      //             cols.push(col)
      //         }
      //       }
      //     }
      //     // MOVE INDEX column to beginning (doesn't work without changing data order too)
      //     let part_idx = col_names.indexOf('Part Number')
      //     if (part_idx >= 0){
      //       col_names.splice(0, 0, col_names.splice(part_idx,1)[0])
      //       cols.splice(0, 0, cols.splice(part_idx,1)[0])
      //     }
      //   }
        
      //   return cols
      // },
      // rows: function(){
      //   let data =this.raw_data.data
      //   // Check for data
      //   if(data.length==0){
      //     // Deep clone the original object
      //     let no_data = JSON.parse(JSON.stringify(this.raw_data.data))
      //     // Display a single row if there's no data
      //     no_data.push({'Data':'None'})
      //     return no_data
      //   }
      //   return data
      // },
      is_paged: function(){
        if(this.rows.length <= 10){
          return false
        }else{
          return true
        }
      }
    },
    methods: {
      // eslint-disable-next-line no-unused-vars
      rowStyleFn(row){
        return 'row_style_class'
      },
      onRowDblClick(args){
        // Capture doubleclick event and re-emit to parent
        this.$emit('on-row-dblclick', args)
      },
      onTableChange(){
        // this.$refs.thisTable.$el.setAttribute('data-TRYTHIS',true)
        // let target_cols = ['Part Number', 'Description', 'Your Price']
        // let cols = document.querySelectorAll("#"+this.raw_data.site + " .vgt-table th")
        // let target_index = {}
        // // Loop through columns and look for targets
        // for(let i=0; i<cols.length; i++){
        //   let col = cols[i]
        //   let txt = col.innerText
        //   if(target_cols.includes(txt)){
        //     target_index[i] = txt.replace(' ','_').toLowerCase()
        //   }
        // }
        // // Loop through rows in thisTable, get values, and append to row data attributes
        // let rows = this.$refs.thisTable.$el.querySelectorAll(".vgt-table tbody>tr") //"#"+this.raw_data.site + 
        // for(let j=0; j<rows.length; j++){
        //   let row = rows[j]
        //   row.setAttribute('data-TRYTHIS',true)
        //   // let tds = row.querySelectorAll("td")
        //   // if (tds.length == 0){
        //   //     continue
        //   //   }
        //   // for(let idx in target_index){
        //   //   if (tds.length < parseInt(idx)){
        //   //     continue
        //   //   }
        //   //   let td = tds[idx]
        //   //   // let c = parseInt(idx)+1
        //   //   // let query = "td:nth-child("+c+")"
        //   //   // let el = row.querySelector(query) //<----------------- ERROR
        //   //   // let e = document.querySelector("#"+this.raw_data.site + " .vgt-table tr:nth-child("+j+") td:nth-child("+c+")")
        //   //   let val = td.innerText
        //   //   // eslint-disable-next-line no-unused-vars
        //   //   // let v = el.innerText
        //   //   let attr = 'data-'+ target_index[idx]
        //   //   row.setAttribute(attr, val);
        //   // }
        // }
        // // this.$refs.thisTable.$forceUpdate
        // // this.$forceUpdate
      },
      rowDrag(e){
        e.dataTransfer.dropEffect = "copy"; // copy, move, link
        let data = {}
        let target = e.target
        data.vendor = target.getAttribute('data-vendor')
        data.part = target.getAttribute('data-part')
        data.desc = target.getAttribute('data-desc')
        data.cost = target.getAttribute('data-cost')
        // let data = e.target.outerHTML
        e.dataTransfer.setData("text/html", JSON.stringify(data));
      },
    },
    updated: function(){
      
    },
    data(){
      return {
      }
    }
  }
</script>